import { render, staticRenderFns } from "./addMerchantShopInfo.vue?vue&type=template&id=52bb09f5"
import script from "./addMerchantShopInfo.vue?vue&type=script&lang=js"
export * from "./addMerchantShopInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports